import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import useLodgeData from '../../../hooks/ui_hooks/useLodgeData';
import { getExpirationPoints } from '../../../store/componentStores/Account/account.selectors';
import { getIsLoyaltyPointsExpirationOnProfileEnabled } from '../../../store/componentStores/LodgeConfig/lodgeConfig.selectors';
import { showLoyalty } from '../../../store/reducers';
import { getTermsAndConditionUrl } from '../../../utilities/navigationUtils';
import { GwDatesWrapper } from '../../_internal_date_/gwDatesWrapper';
import { Box, Button, Flex, Text, TextLink } from '../../ui-kit';
import theme from '../../ui-kit/themes/theme';
import { editCopyByReplaceMultipleStrings, editCopyByReplaceString } from '../../utilities/copyFunctions';
import { LOYALTY_IMAGES } from '../assets/images';
import {
  BookNowWhite,
  Icon,
  LoyaltyProfileContainer,
  PointConditionsAndTerms,
  PointsContainer,
  PointsExpirationContainer,
  PointsInnerFlexContainer,
  SpanDot
} from '../assets/styles';
import * as COPY from '../utilities/copy';

const DotItemOnList = ({ mb, text }) => {
  return (
    <Flex alignItems="center" flexDirection="row" mb={mb}>
      <SpanDot width={5} height={5} mr={8} />
      <Text fontSize={[0, 0, 0, 1]} fontWeight="medium" lineHeight={'150%'} color={'deepForestGreen.100'}>
        {text}
      </Text>
    </Flex>
  );
};

const LoyaltyProfilePoints = ({
  amount,
  iconLink,
  showLoyalty,
  expirationPointsObject,
  isLoyaltyPointsExpirationOnProfileEnabled
}) => {
  const { resortLocationUrl, resortPhone } = useLodgeData();

  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.xl})`
  });

  const { nextExpirationDate, expiringMetricValue } = expirationPointsObject;

  const expirationObject = {
    '<POINTS>': expiringMetricValue ?? 0,
    '<DATE>': GwDatesWrapper.format(nextExpirationDate, 'MMM DD, YYYY')
  };

  return (
    <>
      {showLoyalty ? (
        <LoyaltyProfileContainer>
          {expirationPointsObject && expiringMetricValue !== 0 && isLoyaltyPointsExpirationOnProfileEnabled ? (
            <PointsExpirationContainer>
              <SpanDot />
              <Text
                fontSize={[0, 0, 0, 0, 1]}
                fontWeight="bold"
                color={'voyagersColors.100'}
                lineHeight={[16, 16, 16, 16, 20]}>
                {editCopyByReplaceMultipleStrings(COPY.EXPIRATION_POINTS, expirationObject)}
              </Text>
            </PointsExpirationContainer>
          ) : null}

          <PointsContainer>
            <Box textAlign={isMobile ? 'center' : 'left'} mb={[3]}>
              <Text color={'pureWhite.0'} fontSize={[7]} fontWeight="bold" lineHeight={[22, 22, 22, 22, 24]}>
                {COPY.AVAILABLE_VOYAGERS_POINTS}
              </Text>
            </Box>
            <PointsInnerFlexContainer>
              <Box mb={[4, 4, 4, 4, 0]}>
                <Flex flexDirection="column" width="100%">
                  <Flex justifyContent={isMobile ? 'center' : 'start'} alignItems="center" flexDirection="row">
                    <Icon size="32px" src={iconLink} alt="Loyalty" />
                    <Text
                      ml="12px"
                      color={'voyagersMoonlight'}
                      fontSize={[6, 6, 6, 6, 13]}
                      fontWeight={'heavy'}
                      lineHeight={'112%'}>
                      {amount}
                    </Text>
                    <Text
                      ml={1}
                      color={'voyagersMoonlight'}
                      fontSize={[4, 4, 4, 4, 5]}
                      fontWeight="heavy"
                      lineHeight={'112%'}>
                      {COPY.POINTS}
                    </Text>
                  </Flex>
                </Flex>
              </Box>
              <Box>
                <BookNowWhite>
                  <Button
                    fluid={true}
                    variant={'secondaryLoyalty2025'}
                    as="a"
                    href={`${resortLocationUrl}plan`}
                    size={'desktopLarge2025'}>
                    {COPY.BOOK_NOW}
                  </Button>
                </BookNowWhite>
              </Box>
            </PointsInnerFlexContainer>
          </PointsContainer>
          <PointConditionsAndTerms>
            <Box>
              <DotItemOnList mb={[9, 9, 9, 9, '7px']} text={COPY.USE_POINTS_NEXT_BOOKING} />
              <DotItemOnList mb={[9, 9, 9, 9, '7px']} text={COPY.POINTS_ADDED_UPON_COMPLETION} />
              <DotItemOnList mb={7} text={COPY.TEMP_EXPIRATION_NOTICE} />
              <Box textAlign={'left'} mb={['24px', '24px', '24px', '24px', '0px']}>
                <TextLink
                  href={getTermsAndConditionUrl()}
                  target="_blank"
                  underline
                  color={'deepForestGreen.100'}
                  fontSize={[0]}
                  fontWeight="bold"
                  lineHeight={'150%'}>
                  {COPY.SEE_TERMS_AND_CONDITIONS}
                </TextLink>
              </Box>
            </Box>
            <Box textAlign={isMobile ? 'left' : 'right'}>
              <Text fontSize={[0]} fontWeight="medium" lineHeight={[16]} color={'deepForestGreen.100'}>
                {editCopyByReplaceString(COPY.CLOSE_ACCOUNT, resortPhone, '<<phone>>')}
              </Text>
            </Box>
          </PointConditionsAndTerms>
        </LoyaltyProfileContainer>
      ) : null}
    </>
  );
};

LoyaltyProfilePoints.propTypes = {
  amount: PropTypes.number,
  iconLink: PropTypes.string,
  showLoyalty: PropTypes.bool,
  locationPhone: PropTypes.string,
  expirationPointsObject: PropTypes.object
};
LoyaltyProfilePoints.defaultProps = {
  amount: '0',
  iconLink: LOYALTY_IMAGES.ADVENTURE_BUCK_COIN_WHITE,
  showLoyalty: false,
  locationPhone: '',
  expirationPointsObject: {
    nextExpirationDate: '',
    expiringMetricValue: 0
  }
};

const mapStateToProps = state => ({
  showLoyalty: showLoyalty(state),
  expirationPointsObject: getExpirationPoints(state.account),
  isLoyaltyPointsExpirationOnProfileEnabled: getIsLoyaltyPointsExpirationOnProfileEnabled(state.lodgeConfig)
});

export default connect(mapStateToProps, null)(LoyaltyProfilePoints);
